import http from '../assets/jslibs/axios/http';

//获取轮播图信息
export const getCarousel = function() {
	return http.get('/v1/app/Carousel');
}

//获取服务项目
export const getServer = function() {
	return http.get('/v1/app/Server');
}

//获取用户评论
// export const getComment = function(data) {
// 	return http.get('/v1/app/Comment',data);
// }
// 

export const getComment = (data) => http.get('/v1/app/Comment',data);

//获取用户钱包明细列表
export const getBalanceRecord = function(data) {
	return http.get('/v1/app/UserBalanceRecord', data);
}

//获取充值档次列表
export const getRechargeClassList = function() {
	return http.get('/v1/app/Recharge');
}
